import { __spreadArray } from "tslib";
import React, { Fragment, memo } from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import { v1 } from 'uuid';
var CustomerProfileLoading = function () { return (React.createElement(Fragment, null,
    React.createElement(Grid, { item: true, columnGap: 1, display: "grid", gridTemplateColumns: "auto 100px", justifyContent: "left", mb: 1 },
        React.createElement(Skeleton, { height: 40, variant: "circular", width: 40 }),
        React.createElement(Skeleton, { sx: { fontSize: '1rem' } })),
    __spreadArray([], new Array(10), true).map(function () { return (React.createElement(Box, { key: v1(), component: Skeleton, height: 56, mb: 1, variant: "rounded", width: "100%" })); }))); };
export default memo(CustomerProfileLoading);
//# sourceMappingURL=CustomerProfileLoading.js.map